import * as PriceFactorsGroups from './priceFactorsGroups';
import * as PriceFactorsProductCodes from './priceFactorsProductCodes';
import * as PriceFactorsList from './priceFactorsList';
import * as AddPriceFactor from './addPriceFactor';

const Actions = {
  ...PriceFactorsGroups,
  ...PriceFactorsProductCodes,
  ...PriceFactorsList,
  ...AddPriceFactor,
};

export default Actions;
